export const getFromLS = key => JSON.parse(localStorage.getItem(key));
